import { useQuery } from '@showroomjs/bundles/query';
import { getCompilationKey, } from '@showroomjs/core';
import { addMissingImports } from './add-missing-imports';
import { useCodeImports } from './code-imports-context';
export const useCodeCompilationCache = (providedCode, lang) => {
    const code = providedCode.trim();
    return useQuery(getCompilationKey(code, lang), {
        enabled: false,
    });
};
export const useCodeCompilation = (providedCode, lang, options = {}) => {
    const code = providedCode.trim();
    const precompiledImports = useCodeImports();
    const result = useQuery(Object.assign({ queryKey: getCompilationKey(code, lang), queryFn: () => import(/* webpackChunkName: "compileCode" */ './compile-code')
            .then((m) => m.compileCode(code, lang))
            .then((result) => {
            if (result.type === 'error') {
                return Promise.resolve(result);
            }
            return new Promise((fulfill) => {
                addMissingImports(precompiledImports, result.importedPackages, (imports) => fulfill(Object.assign(Object.assign({}, result), { imports })));
            });
        }), keepPreviousData: true }, options));
    return Object.assign(Object.assign({}, result), { isCompiling: result.isLoading || result.isFetching });
};
//# sourceMappingURL=use-code-compilation.js.map